var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8331 8.16665C38.1331 6.19998 41.8998 6.19998 44.2331 8.16665L49.4998 12.7C50.4998 13.5667 52.3664 14.2667 53.6998 14.2667H59.3664C62.8998 14.2667 65.7998 17.1667 65.7998 20.7V26.3666C65.7998 27.6667 66.4998 29.5667 67.3664 30.5667L71.8998 35.8333C73.8664 38.1333 73.8664 41.9 71.8998 44.2333L67.3664 49.5C66.4998 50.5 65.7998 52.3667 65.7998 53.7V59.3667C65.7998 62.9 62.8998 65.8 59.3664 65.8H53.6998C52.3998 65.8 50.4998 66.5 49.4998 67.3666L44.2331 71.9C41.9331 73.8667 38.1664 73.8667 35.8331 71.9L30.5664 67.3666C29.5664 66.5 27.6998 65.8 26.3664 65.8H20.5998C17.0664 65.8 14.1664 62.9 14.1664 59.3667V53.6667C14.1664 52.3667 13.4664 50.5 12.6331 49.5L8.13311 44.2C6.19977 41.9 6.19977 38.1667 8.13311 35.8667L12.6331 30.5667C13.4664 29.5667 14.1664 27.7 14.1664 26.4V20.6666C14.1664 17.1333 17.0664 14.2333 20.5998 14.2333H26.3664C27.6664 14.2333 29.5664 13.5333 30.5664 12.6667L35.8331 8.16665Z",
    fill: "url(#paint0_linear_388_883)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9341 40.0003L35.9674 48.0669L52.0674 31.9336",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_883",
    x1: 5.01581,
    y1: 6.69165,
    x2: 71.6991,
    y2: 73.3833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00EE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#00A15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04824B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.ec3ff2633b0922f672906f86a3915c18.svg";
export { ForwardRef as ReactComponent };